// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/worker.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta, ResponseMeta, WorkerBackupStatus, WorkerProductContract } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { PublicWebTunnelAssignment } from "./public_web_pb";
import { file_nodebase_v1_public_web } from "./public_web_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/worker.proto.
 */
export const file_nodebase_v1_worker: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common, file_nodebase_v1_public_web]);

/**
 * WGTLSConfig carries only stable, versioned properties of a WG_TLS endpoint.
 * Per-device route tickets and carrier credentials are returned separately by
 * NetworkService so they can rotate without changing NetworkConfig identity.
 * effective_mtu=0 means use the platform default until carrier-specific
 * measurement sets one.
 *
 * @generated from message nodebase.v1.WGTLSConfig
 */
export type WGTLSConfig = Message<"nodebase.v1.WGTLSConfig"> & {
  /**
   * @generated from field: string server_name = 1;
   */
  serverName: string;

  /**
   * @generated from field: uint32 effective_mtu = 3;
   */
  effectiveMtu: number;

  /**
   * @generated from field: bool strict_mode = 6;
   */
  strictMode: boolean;
};

/**
 * Describes the message nodebase.v1.WGTLSConfig.
 * Use `create(WGTLSConfigSchema)` to create a new message.
 */
export const WGTLSConfigSchema: GenMessage<WGTLSConfig> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 0);

/**
 * WGQUICConfig contains only stable properties of the shared UDP carrier.
 * Passwords and route tickets rotate in GetNetworkConfigResponse and therefore
 * never enter the content-addressed NetworkConfig.
 *
 * @generated from message nodebase.v1.WGQUICConfig
 */
export type WGQUICConfig = Message<"nodebase.v1.WGQUICConfig"> & {
  /**
   * @generated from field: string server_name = 1;
   */
  serverName: string;

  /**
   * @generated from field: uint32 effective_mtu = 2;
   */
  effectiveMtu: number;
};

/**
 * Describes the message nodebase.v1.WGQUICConfig.
 * Use `create(WGQUICConfigSchema)` to create a new message.
 */
export const WGQUICConfigSchema: GenMessage<WGQUICConfig> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 1);

/**
 * Endpoint is one candidate way to reach a node. relay-type endpoints (via_edge
 * + relay_route_id) are P0-reserved and unused in P1 (technical plan §3.6).
 *
 * @generated from message nodebase.v1.Endpoint
 */
export type Endpoint = Message<"nodebase.v1.Endpoint"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: uint32 port = 2;
   */
  port: number;

  /**
   * @generated from field: nodebase.v1.Transport transport = 3;
   */
  transport: Transport;

  /**
   * @generated from field: int32 priority = 4;
   */
  priority: number;

  /**
   * @generated from field: string via_edge = 5;
   */
  viaEdge: string;

  /**
   * @generated from field: string relay_route_id = 6;
   */
  relayRouteId: string;

  /**
   * Stable within a peer across NetworkConfig versions. Selection history is
   * keyed by this value rather than a mutable candidate-array index.
   *
   * @generated from field: string id = 7;
   */
  id: string;

  /**
   * @generated from field: nodebase.v1.WGTLSConfig wg_tls = 8;
   */
  wgTls?: WGTLSConfig | undefined;

  /**
   * @generated from field: nodebase.v1.WGQUICConfig wg_quic = 9;
   */
  wgQuic?: WGQUICConfig | undefined;

  /**
   * Stable wire-profile identity inside the coarse transport class. Empty is
   * the legacy profile for older producers; new producers use a versioned id
   * such as hy2-salamander-v1 or stls-go-v1. A port never implies a profile.
   *
   * @generated from field: string profile_id = 10;
   */
  profileId: string;
};

/**
 * Describes the message nodebase.v1.Endpoint.
 * Use `create(EndpointSchema)` to create a new message.
 */
export const EndpointSchema: GenMessage<Endpoint> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 2);

/**
 * @generated from message nodebase.v1.WorkerSpec
 */
export type WorkerSpec = Message<"nodebase.v1.WorkerSpec"> & {
  /**
   * @generated from field: uint32 vcpu = 1;
   */
  vcpu: number;

  /**
   * @generated from field: uint32 mem_mb = 2;
   */
  memMb: number;

  /**
   * @generated from field: uint32 disk_gb = 3;
   */
  diskGb: number;
};

/**
 * Describes the message nodebase.v1.WorkerSpec.
 * Use `create(WorkerSpecSchema)` to create a new message.
 */
export const WorkerSpecSchema: GenMessage<WorkerSpec> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 3);

/**
 * @generated from message nodebase.v1.Worker
 */
export type Worker = Message<"nodebase.v1.Worker"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string region = 4;
   */
  region: string;

  /**
   * @generated from field: nodebase.v1.WorkerSpec spec = 5;
   */
  spec?: WorkerSpec | undefined;

  /**
   * @generated from field: nodebase.v1.WorkerState state = 6;
   */
  state: WorkerState;

  /**
   * @generated from field: bytes api_public_key = 7;
   */
  apiPublicKey: Uint8Array;

  /**
   * @generated from field: bytes wg_public_key = 8;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: string overlay_ip = 9;
   */
  overlayIp: string;

  /**
   * @generated from field: repeated nodebase.v1.Endpoint endpoints = 10;
   */
  endpoints: Endpoint[];

  /**
   * Reserved home-relay assignment (technical plan §3.6); empty in P1.
   *
   * @generated from field: repeated string home_edges = 11;
   */
  homeEdges: string[];

  /**
   * @generated from field: uint64 desired_config_version = 12;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: uint64 observed_config_version = 13;
   */
  observedConfigVersion: bigint;

  /**
   * @generated from field: string agent_version = 14;
   */
  agentVersion: string;

  /**
   * @generated from field: int64 last_heartbeat_unix = 15;
   */
  lastHeartbeatUnix: bigint;

  /**
   * The Worker's persistent SSH host identity, reported by the authenticated
   * agent and pinned by the control plane. Raw Ed25519 public-key bytes, not an
   * authorized_keys line. Clients bind this to id (not the reusable overlay
   * address) when generating their managed known_hosts file.
   *
   * @generated from field: bytes ssh_host_public_key = 16;
   */
  sshHostPublicKey: Uint8Array;

  /**
   * Stable product behavior rendered by every account-facing surface. Storage
   * protection comes from this Worker's authoritative database row.
   *
   * @generated from field: nodebase.v1.WorkerProductContract product_contract = 17;
   */
  productContract?: WorkerProductContract | undefined;

  /**
   * Platform-backup readings behind product_contract.data.independent_backup.
   * Absent when no backup job has ever reported for this Worker.
   *
   * @generated from field: nodebase.v1.WorkerBackupStatus backup_status = 18;
   */
  backupStatus?: WorkerBackupStatus | undefined;

  /**
   * First-setup progress, present from the moment the Worker is reserved until
   * it first becomes ready (docs/worker-setup-progress.md). Derived on every
   * read from lifecycle facts the control plane already records; never
   * stored, and never a client-side estimate.
   *
   * @generated from field: nodebase.v1.WorkerSetup setup = 19;
   */
  setup?: WorkerSetup | undefined;
};

/**
 * Describes the message nodebase.v1.Worker.
 * Use `create(WorkerSchema)` to create a new message.
 */
export const WorkerSchema: GenMessage<Worker> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 4);

/**
 * @generated from message nodebase.v1.WorkerSetup
 */
export type WorkerSetup = Message<"nodebase.v1.WorkerSetup"> & {
  /**
   * @generated from field: nodebase.v1.WorkerSetupStage stage = 1;
   */
  stage: WorkerSetupStage;

  /**
   * @generated from field: nodebase.v1.WorkerSetupProblem problem = 2;
   */
  problem: WorkerSetupProblem;

  /**
   * Durations measured by the server at read time. A client adds the time
   * since its own read instead of comparing timestamps with its own clock.
   *
   * @generated from field: uint32 elapsed_seconds = 3;
   */
  elapsedSeconds: number;

  /**
   * @generated from field: uint32 stage_elapsed_seconds = 4;
   */
  stageElapsedSeconds: number;

  /**
   * QUEUED only: Workers the regional host sets up before this one.
   *
   * @generated from field: uint32 queue_ahead = 5;
   */
  queueAhead: number;

  /**
   * RETRYING only: seconds until the server's next attempt (0 = due now).
   *
   * @generated from field: uint32 retry_in_seconds = 6;
   */
  retryInSeconds: number;
};

/**
 * Describes the message nodebase.v1.WorkerSetup.
 * Use `create(WorkerSetupSchema)` to create a new message.
 */
export const WorkerSetupSchema: GenMessage<WorkerSetup> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 5);

/**
 * @generated from message nodebase.v1.ResourceUsage
 */
export type ResourceUsage = Message<"nodebase.v1.ResourceUsage"> & {
  /**
   * @generated from field: double cpu_pct = 1;
   */
  cpuPct: number;

  /**
   * @generated from field: uint64 mem_used_mb = 2;
   */
  memUsedMb: bigint;

  /**
   * @generated from field: uint64 disk_used_mb = 3;
   */
  diskUsedMb: bigint;
};

/**
 * Describes the message nodebase.v1.ResourceUsage.
 * Use `create(ResourceUsageSchema)` to create a new message.
 */
export const ResourceUsageSchema: GenMessage<ResourceUsage> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 6);

/**
 * ObservedState is what the agent reports about itself each heartbeat.
 *
 * @generated from message nodebase.v1.ObservedState
 */
export type ObservedState = Message<"nodebase.v1.ObservedState"> & {
  /**
   * @generated from field: uint64 config_version = 1;
   */
  configVersion: bigint;

  /**
   * @generated from field: string config_hash = 2;
   */
  configHash: string;

  /**
   * @generated from field: string health_summary = 3;
   */
  healthSummary: string;

  /**
   * @generated from field: string services_summary = 4;
   */
  servicesSummary: string;

  /**
   * @generated from field: nodebase.v1.ResourceUsage resource_usage = 5;
   */
  resourceUsage?: ResourceUsage | undefined;

  /**
   * Cumulative WireGuard interface counters since the interface came up.
   * Reset (to a smaller value) on rebuild/restart; the server keeps the
   * last report per worker, not a ledger — coarse accounting for the
   * global-egress mode, not billing.
   *
   * @generated from field: uint64 wg_rx_bytes = 6;
   */
  wgRxBytes: bigint;

  /**
   * @generated from field: uint64 wg_tx_bytes = 7;
   */
  wgTxBytes: bigint;

  /**
   * Per-peer view of the same interface, so the control plane can attribute
   * the aggregate counters and tell which devices actually hold a live tunnel
   * (a device's own poll proves it reaches the control plane, not the worker).
   * The server matches entries to devices by wg_public_key.
   *
   * @generated from field: repeated nodebase.v1.PeerStat peers = 8;
   */
  peers: PeerStat[];

  /**
   * Per-device downlink pacing for the interval since the last heartbeat. See
   * DownlinkPace: this is the demand evidence a device cannot observe about
   * itself, without which every throughput window it opens must abstain.
   *
   * @generated from field: repeated nodebase.v1.DownlinkPace downlink_pace = 13;
   */
  downlinkPace: DownlinkPace[];

  /**
   * Persistent SSH host identity from the Worker's state volume. The control
   * plane accepts the first authenticated value and rejects silent changes.
   *
   * @generated from field: bytes ssh_host_public_key = 9;
   */
  sshHostPublicKey: Uint8Array;

  /**
   * The port read back from the live WireGuard interface. Generation
   * promotion compares this independent data-plane fact with the provider's
   * reserved/mapped endpoint; config-version convergence alone is not ready.
   *
   * @generated from field: uint32 wg_listen_port = 15;
   */
  wgListenPort: number;

  /**
   * in_use says a person is using this Worker right now — an open SSH
   * session, or an interactive managed service serving — so a rolling
   * rebuild should wait for them (worker-evolution-plan W4 ①). Control defers
   * such a Worker up to NODEBASE_REBUILD_DEFER_MAX_SEC and no longer; the
   * reason is what an operator reads when a wave looks stuck.
   *
   * @generated from field: bool in_use = 16;
   */
  inUse: boolean;

  /**
   * @generated from field: string in_use_reason = 17;
   */
  inUseReason: string;
};

/**
 * Describes the message nodebase.v1.ObservedState.
 * Use `create(ObservedStateSchema)` to create a new message.
 */
export const ObservedStateSchema: GenMessage<ObservedState> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 7);

/**
 * PeerStat is one WG peer as the worker's interface sees it. The endpoint is
 * the peer's source address after NAT — for a device, its public address —
 * which is operator material: surfaces below the admin console must blank it
 * (the same rule Device.wg_endpoint states for the read side).
 *
 * @generated from message nodebase.v1.PeerStat
 */
export type PeerStat = Message<"nodebase.v1.PeerStat"> & {
  /**
   * @generated from field: bytes wg_public_key = 1;
   */
  wgPublicKey: Uint8Array;

  /**
   * 0: never completed one
   *
   * @generated from field: int64 last_handshake_unix = 2;
   */
  lastHandshakeUnix: bigint;

  /**
   * cumulative, same reset semantics as wg_rx_bytes
   *
   * @generated from field: uint64 rx_bytes = 3;
   */
  rxBytes: bigint;

  /**
   * @generated from field: uint64 tx_bytes = 4;
   */
  txBytes: bigint;

  /**
   * "ip:port"; empty when the peer never connected
   *
   * @generated from field: string endpoint = 5;
   */
  endpoint: string;
};

/**
 * Describes the message nodebase.v1.PeerStat.
 * Use `create(PeerStatSchema)` to create a new message.
 */
export const PeerStatSchema: GenMessage<PeerStat> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 8);

/**
 * DownlinkPace answers the one question a device cannot answer about its own
 * receive rate: was the tunnel, or the internet, the thing setting the pace.
 *
 * A device measuring 100 KB/s cannot tell a throttled link from an idle user.
 * Only the sender knows it had more to send, and for the downlink that sender
 * is the Worker. Read-bound means the internet paced it and the window says
 * nothing about the link; write-bound means the Worker had data in hand and
 * the tunnel would not take it, which is the demand evidence the throughput
 * contract requires before any rate may be judged.
 *
 * Keyed by overlay address rather than WG key: the control plane already maps
 * one to a device, so the relay does not carry an identity down every
 * connection for the sake of one counter. Values cover the interval since the
 * previous heartbeat and reset with it, so a device that was write-bound an
 * hour ago does not keep looking write-bound now.
 *
 * The two durations belong to one connection, not to the device's whole set.
 * Blocked time from concurrent flows is not additive — nine of them can report
 * 270s inside a 30s window — and a read is charged whole to the window it
 * completes in, so an idle socket dumps minutes of waiting the instant it
 * receives a byte. Summed, those waits always outvote the one flow the tunnel
 * actually refused. The Worker therefore reports the flow with the largest
 * write-over-read margin among those that carried bytes, which makes
 * write_nanos > read_nanos true exactly when some flow had data the tunnel
 * would not take. bytes stays the device's total for the interval.
 *
 * @generated from message nodebase.v1.DownlinkPace
 */
export type DownlinkPace = Message<"nodebase.v1.DownlinkPace"> & {
  /**
   * @generated from field: string overlay_address = 1;
   */
  overlayAddress: string;

  /**
   * that flow's time blocked reading from the internet
   *
   * @generated from field: int64 read_nanos = 2;
   */
  readNanos: bigint;

  /**
   * that flow's time blocked writing into the tunnel
   *
   * @generated from field: int64 write_nanos = 3;
   */
  writeNanos: bigint;

  /**
   * moved toward the device in this interval, across all flows
   *
   * @generated from field: int64 bytes = 4;
   */
  bytes: bigint;
};

/**
 * Describes the message nodebase.v1.DownlinkPace.
 * Use `create(DownlinkPaceSchema)` to create a new message.
 */
export const DownlinkPaceSchema: GenMessage<DownlinkPace> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 9);

/**
 * @generated from message nodebase.v1.CreateWorkerRequest
 */
export type CreateWorkerRequest = Message<"nodebase.v1.CreateWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: nodebase.v1.WorkerSpec spec = 3;
   */
  spec?: WorkerSpec | undefined;

  /**
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.CreateWorkerRequest.
 * Use `create(CreateWorkerRequestSchema)` to create a new message.
 */
export const CreateWorkerRequestSchema: GenMessage<CreateWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 10);

/**
 * @generated from message nodebase.v1.EnsureWorkerRequest
 */
export type EnsureWorkerRequest = Message<"nodebase.v1.EnsureWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.EnsureWorkerRequest.
 * Use `create(EnsureWorkerRequestSchema)` to create a new message.
 */
export const EnsureWorkerRequestSchema: GenMessage<EnsureWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 11);

/**
 * @generated from message nodebase.v1.EnsureWorkerResponse
 */
export type EnsureWorkerResponse = Message<"nodebase.v1.EnsureWorkerResponse"> & {
  /**
   * @generated from field: nodebase.v1.Worker worker = 1;
   */
  worker?: Worker | undefined;

  /**
   * True when this call provisioned the worker (first connect), so the client
   * can explain the wait instead of implying something existed all along.
   *
   * @generated from field: bool created = 2;
   */
  created: boolean;
};

/**
 * Describes the message nodebase.v1.EnsureWorkerResponse.
 * Use `create(EnsureWorkerResponseSchema)` to create a new message.
 */
export const EnsureWorkerResponseSchema: GenMessage<EnsureWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 12);

/**
 * @generated from message nodebase.v1.CreateWorkerResponse
 */
export type CreateWorkerResponse = Message<"nodebase.v1.CreateWorkerResponse"> & {
  /**
   * @generated from field: nodebase.v1.Worker worker = 1;
   */
  worker?: Worker | undefined;

  /**
   * One-time bootstrap credential, returned exactly once for the provisioner to
   * inject into the new worker. Only its hash is stored (technical plan §3.3).
   *
   * @generated from field: string bootstrap_token = 2;
   */
  bootstrapToken: string;
};

/**
 * Describes the message nodebase.v1.CreateWorkerResponse.
 * Use `create(CreateWorkerResponseSchema)` to create a new message.
 */
export const CreateWorkerResponseSchema: GenMessage<CreateWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 13);

/**
 * @generated from message nodebase.v1.ListWorkersRequest
 */
export type ListWorkersRequest = Message<"nodebase.v1.ListWorkersRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * Empty means the account's default workspace, like every business RPC.
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.ListWorkersRequest.
 * Use `create(ListWorkersRequestSchema)` to create a new message.
 */
export const ListWorkersRequestSchema: GenMessage<ListWorkersRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 14);

/**
 * @generated from message nodebase.v1.ListWorkersResponse
 */
export type ListWorkersResponse = Message<"nodebase.v1.ListWorkersResponse"> & {
  /**
   * @generated from field: repeated nodebase.v1.Worker workers = 1;
   */
  workers: Worker[];
};

/**
 * Describes the message nodebase.v1.ListWorkersResponse.
 * Use `create(ListWorkersResponseSchema)` to create a new message.
 */
export const ListWorkersResponseSchema: GenMessage<ListWorkersResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 15);

/**
 * @generated from message nodebase.v1.GetWorkerRequest
 */
export type GetWorkerRequest = Message<"nodebase.v1.GetWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId: string;
};

/**
 * Describes the message nodebase.v1.GetWorkerRequest.
 * Use `create(GetWorkerRequestSchema)` to create a new message.
 */
export const GetWorkerRequestSchema: GenMessage<GetWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 16);

/**
 * @generated from message nodebase.v1.GetWorkerResponse
 */
export type GetWorkerResponse = Message<"nodebase.v1.GetWorkerResponse"> & {
  /**
   * @generated from field: nodebase.v1.Worker worker = 1;
   */
  worker?: Worker | undefined;
};

/**
 * Describes the message nodebase.v1.GetWorkerResponse.
 * Use `create(GetWorkerResponseSchema)` to create a new message.
 */
export const GetWorkerResponseSchema: GenMessage<GetWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 17);

/**
 * @generated from message nodebase.v1.RegisterWorkerRequest
 */
export type RegisterWorkerRequest = Message<"nodebase.v1.RegisterWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string bootstrap_token = 2;
   */
  bootstrapToken: string;

  /**
   * @generated from field: bytes api_public_key = 3;
   */
  apiPublicKey: Uint8Array;

  /**
   * @generated from field: bytes wg_public_key = 4;
   */
  wgPublicKey: Uint8Array;

  /**
   * @generated from field: string agent_version = 5;
   */
  agentVersion: string;

  /**
   * The publicly reachable endpoint the agent listens on: the host's address and
   * the UDP port mapped to this worker's container (technical plan §4.1).
   *
   * @generated from field: string endpoint_host = 6;
   */
  endpointHost: string;

  /**
   * @generated from field: uint32 endpoint_port = 7;
   */
  endpointPort: number;
};

/**
 * Describes the message nodebase.v1.RegisterWorkerRequest.
 * Use `create(RegisterWorkerRequestSchema)` to create a new message.
 */
export const RegisterWorkerRequestSchema: GenMessage<RegisterWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 18);

/**
 * @generated from message nodebase.v1.RegisterWorkerResponse
 */
export type RegisterWorkerResponse = Message<"nodebase.v1.RegisterWorkerResponse"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string overlay_ip = 2;
   */
  overlayIp: string;

  /**
   * @generated from field: uint64 desired_config_version = 3;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: nodebase.v1.ResponseMeta meta = 4;
   */
  meta?: ResponseMeta | undefined;
};

/**
 * Describes the message nodebase.v1.RegisterWorkerResponse.
 * Use `create(RegisterWorkerResponseSchema)` to create a new message.
 */
export const RegisterWorkerResponseSchema: GenMessage<RegisterWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 19);

/**
 * @generated from message nodebase.v1.HeartbeatRequest
 */
export type HeartbeatRequest = Message<"nodebase.v1.HeartbeatRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string agent_version = 2;
   */
  agentVersion: string;

  /**
   * @generated from field: nodebase.v1.ObservedState observed = 3;
   */
  observed?: ObservedState | undefined;

  /**
   * Caller identity. Superseded by signature-based node auth (§3.3), after which
   * the server derives identity from the credential rather than trusting this.
   *
   * @generated from field: string worker_id = 4;
   */
  workerId: string;

  /**
   * Immutable process authority. Both are zero only for a legacy container;
   * generation-aware Control rejects a stale generation before accepting any
   * mutable observation from it.
   *
   * @generated from field: uint64 generation = 9;
   */
  generation: bigint;

  /**
   * @generated from field: uint64 lease_epoch = 10;
   */
  leaseEpoch: bigint;

  /**
   * @generated from field: bool public_web_multi_tunnel = 11;
   */
  publicWebMultiTunnel: boolean;
};

/**
 * Describes the message nodebase.v1.HeartbeatRequest.
 * Use `create(HeartbeatRequestSchema)` to create a new message.
 */
export const HeartbeatRequestSchema: GenMessage<HeartbeatRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 20);

/**
 * @generated from message nodebase.v1.HeartbeatResponse
 */
export type HeartbeatResponse = Message<"nodebase.v1.HeartbeatResponse"> & {
  /**
   * @generated from field: nodebase.v1.ResponseMeta meta = 1;
   */
  meta?: ResponseMeta | undefined;

  /**
   * @generated from field: uint64 desired_config_version = 2;
   */
  desiredConfigVersion: bigint;

  /**
   * @generated from field: string min_compat_agent_version = 3;
   */
  minCompatAgentVersion: string;

  /**
   * @generated from field: bool pending_events = 4;
   */
  pendingEvents: boolean;

  /**
   * Explicit canary homes for an outbound Worker→Edge relay session. Tickets
   * rotate with heartbeat and are not persisted in the Worker record.
   *
   * @generated from field: repeated nodebase.v1.WorkerRelayHome relay_homes = 5;
   */
  relayHomes: WorkerRelayHome[];

  /**
   * Complete current admission snapshot for Device -> own Worker public Exit.
   * Presence at the exact generation authorizes native Worker egress; absence
   * revokes new and active sessions. Managed Edge never enters this protocol.
   *
   * @generated from field: nodebase.v1.WorkerInternetExitAuthorization internet_exit_authorization = 10;
   */
  internetExitAuthorization?: WorkerInternetExitAuthorization | undefined;

  /**
   * Zero or one assignment in the MVP: one public hostname per Workspace.
   *
   * @generated from field: nodebase.v1.PublicWebTunnelAssignment public_web_tunnel = 11;
   */
  publicWebTunnel?: PublicWebTunnelAssignment | undefined;

  /**
   * Platform-backup readings so the Agent can render `nb info` truthfully.
   * Control evaluates; the Agent only displays. Absent means never reported.
   *
   * @generated from field: nodebase.v1.WorkerBackupStatus backup_status = 12;
   */
  backupStatus?: WorkerBackupStatus | undefined;

  /**
   * @generated from field: repeated nodebase.v1.PublicWebTunnelAssignment public_web_tunnels = 13;
   */
  publicWebTunnels: PublicWebTunnelAssignment[];

  /**
   * @generated from field: bool public_web_tunnels_authoritative = 14;
   */
  publicWebTunnelsAuthoritative: boolean;
};

/**
 * Describes the message nodebase.v1.HeartbeatResponse.
 * Use `create(HeartbeatResponseSchema)` to create a new message.
 */
export const HeartbeatResponseSchema: GenMessage<HeartbeatResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 21);

/**
 * @generated from message nodebase.v1.WorkerInternetExitAuthorization
 */
export type WorkerInternetExitAuthorization = Message<"nodebase.v1.WorkerInternetExitAuthorization"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: repeated nodebase.v1.WorkerInternetExitAdmission admissions = 2;
   */
  admissions: WorkerInternetExitAdmission[];
};

/**
 * Describes the message nodebase.v1.WorkerInternetExitAuthorization.
 * Use `create(WorkerInternetExitAuthorizationSchema)` to create a new message.
 */
export const WorkerInternetExitAuthorizationSchema: GenMessage<WorkerInternetExitAuthorization> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 22);

/**
 * @generated from message nodebase.v1.WorkerInternetExitAdmission
 */
export type WorkerInternetExitAdmission = Message<"nodebase.v1.WorkerInternetExitAdmission"> & {
  /**
   * @generated from field: string device_id = 1;
   */
  deviceId: string;

  /**
   * @generated from field: uint64 generation = 2;
   */
  generation: bigint;

  /**
   * Existing-only admissions are the bounded make-before-break tail. They
   * keep already-open streams alive until expires_unix, but never admit a new
   * stream at this generation.
   *
   * @generated from field: bool existing_only = 3;
   */
  existingOnly: boolean;

  /**
   * @generated from field: int64 expires_unix = 4;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.WorkerInternetExitAdmission.
 * Use `create(WorkerInternetExitAdmissionSchema)` to create a new message.
 */
export const WorkerInternetExitAdmissionSchema: GenMessage<WorkerInternetExitAdmission> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 23);

/**
 * @generated from message nodebase.v1.WorkerRelayHome
 */
export type WorkerRelayHome = Message<"nodebase.v1.WorkerRelayHome"> & {
  /**
   * @generated from field: string edge_node_id = 1;
   */
  edgeNodeId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: repeated nodebase.v1.Endpoint endpoints = 3;
   */
  endpoints: Endpoint[];

  /**
   * @generated from field: string relay_route_id = 4;
   */
  relayRouteId: string;

  /**
   * sensitive; never log or persist
   *
   * @generated from field: string route_ticket = 5;
   */
  routeTicket: string;

  /**
   * @generated from field: int64 expires_unix = 6;
   */
  expiresUnix: bigint;

  /**
   * sensitive ShadowTLS credential
   *
   * @generated from field: string carrier_password = 7;
   */
  carrierPassword: string;

  /**
   * Additional one-time tickets for parallel standby streams. route_ticket
   * above remains slot zero for older Workers. New servers set home_slot;
   * Workers accept zero here as the legacy list-position fallback.
   *
   * @generated from field: repeated nodebase.v1.RelayHomeTicket standby_tickets = 8;
   */
  standbyTickets: RelayHomeTicket[];
};

/**
 * Describes the message nodebase.v1.WorkerRelayHome.
 * Use `create(WorkerRelayHomeSchema)` to create a new message.
 */
export const WorkerRelayHomeSchema: GenMessage<WorkerRelayHome> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 24);

/**
 * @generated from message nodebase.v1.RelayHomeTicket
 */
export type RelayHomeTicket = Message<"nodebase.v1.RelayHomeTicket"> & {
  /**
   * sensitive; never log or persist
   *
   * @generated from field: string route_ticket = 1;
   */
  routeTicket: string;

  /**
   * @generated from field: int64 expires_unix = 2;
   */
  expiresUnix: bigint;

  /**
   * Signed HomeSlot carried inside route_ticket. Explicitly binding the
   * envelope prevents list reordering from changing the local runner key.
   *
   * @generated from field: uint32 home_slot = 3;
   */
  homeSlot: number;
};

/**
 * Describes the message nodebase.v1.RelayHomeTicket.
 * Use `create(RelayHomeTicketSchema)` to create a new message.
 */
export const RelayHomeTicketSchema: GenMessage<RelayHomeTicket> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 25);

/**
 * @generated from message nodebase.v1.ReportStateRequest
 */
export type ReportStateRequest = Message<"nodebase.v1.ReportStateRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: nodebase.v1.ObservedState observed = 2;
   */
  observed?: ObservedState | undefined;

  /**
   * @generated from field: string worker_id = 3;
   */
  workerId: string;
};

/**
 * Describes the message nodebase.v1.ReportStateRequest.
 * Use `create(ReportStateRequestSchema)` to create a new message.
 */
export const ReportStateRequestSchema: GenMessage<ReportStateRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 26);

/**
 * @generated from message nodebase.v1.ReportStateResponse
 */
export type ReportStateResponse = Message<"nodebase.v1.ReportStateResponse"> & {
};

/**
 * Describes the message nodebase.v1.ReportStateResponse.
 * Use `create(ReportStateResponseSchema)` to create a new message.
 */
export const ReportStateResponseSchema: GenMessage<ReportStateResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 27);

/**
 * TrafficDest is one destination's share of a window, already normalized by
 * the agent: registrable domain (eTLD+1) for hostname targets, the literal
 * address for IP targets, or "(other)" for the tail beyond the window's top-N.
 *
 * Alongside volume it carries path-quality counters, the input for "is this
 * destination slow or broken through the worker" (routing optimization).
 * They are sums, so they merge across windows and workers; all four come from
 * TCP dials only — UDP flows have no dial to measure, so they contribute
 * bytes and connections but no quality samples. A destination that only ever
 * fails still appears, with zero bytes.
 *
 * @generated from message nodebase.v1.TrafficDest
 */
export type TrafficDest = Message<"nodebase.v1.TrafficDest"> & {
  /**
   * @generated from field: string dest = 1;
   */
  dest: string;

  /**
   * @generated from field: int64 bytes = 2;
   */
  bytes: bigint;

  /**
   * @generated from field: int64 connections = 3;
   */
  connections: bigint;

  /**
   * Successful TCP dials measured (the divisor for dial_ms_total).
   *
   * @generated from field: int64 dials = 4;
   */
  dials: bigint;

  /**
   * Total milliseconds those dials took (worker-side DNS + TCP handshake).
   *
   * @generated from field: int64 dial_ms_total = 5;
   */
  dialMsTotal: bigint;

  /**
   * Dials that timed out — the path-problem signal.
   *
   * @generated from field: int64 dial_timeouts = 6;
   */
  dialTimeouts: bigint;

  /**
   * Dials that failed for other reasons (refused, unreachable, DNS) — more
   * often the destination's problem than the path's.
   *
   * @generated from field: int64 dial_failures = 7;
   */
  dialFailures: bigint;
};

/**
 * Describes the message nodebase.v1.TrafficDest.
 * Use `create(TrafficDestSchema)` to create a new message.
 */
export const TrafficDestSchema: GenMessage<TrafficDest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 28);

/**
 * TrafficWindow is one closed UTC-hour accounting window of worker egress:
 * what the SOCKS5 egress actually relayed, not WG interface counters. Up is
 * device→internet, down is internet→device.
 *
 * @generated from message nodebase.v1.TrafficWindow
 */
export type TrafficWindow = Message<"nodebase.v1.TrafficWindow"> & {
  /**
   * @generated from field: int64 window_start_unix = 1;
   */
  windowStartUnix: bigint;

  /**
   * @generated from field: int64 up_bytes = 2;
   */
  upBytes: bigint;

  /**
   * @generated from field: int64 down_bytes = 3;
   */
  downBytes: bigint;

  /**
   * @generated from field: int64 connections = 4;
   */
  connections: bigint;

  /**
   * Top destinations of this window. In flight only — see ReportTraffic.
   *
   * @generated from field: repeated nodebase.v1.TrafficDest dests = 5;
   */
  dests: TrafficDest[];
};

/**
 * Describes the message nodebase.v1.TrafficWindow.
 * Use `create(TrafficWindowSchema)` to create a new message.
 */
export const TrafficWindowSchema: GenMessage<TrafficWindow> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 29);

/**
 * @generated from message nodebase.v1.ReportTrafficRequest
 */
export type ReportTrafficRequest = Message<"nodebase.v1.ReportTrafficRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: repeated nodebase.v1.TrafficWindow windows = 2;
   */
  windows: TrafficWindow[];
};

/**
 * Describes the message nodebase.v1.ReportTrafficRequest.
 * Use `create(ReportTrafficRequestSchema)` to create a new message.
 */
export const ReportTrafficRequestSchema: GenMessage<ReportTrafficRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 30);

/**
 * @generated from message nodebase.v1.ReportTrafficResponse
 */
export type ReportTrafficResponse = Message<"nodebase.v1.ReportTrafficResponse"> & {
  /**
   * Window starts the server has durably recorded (including ones it already
   * had); the agent marks these reported and stops sending them.
   *
   * @generated from field: repeated int64 acked_window_start_unix = 1;
   */
  ackedWindowStartUnix: bigint[];
};

/**
 * Describes the message nodebase.v1.ReportTrafficResponse.
 * Use `create(ReportTrafficResponseSchema)` to create a new message.
 */
export const ReportTrafficResponseSchema: GenMessage<ReportTrafficResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 31);

/**
 * @generated from message nodebase.v1.DestroyWorkerRequest
 */
export type DestroyWorkerRequest = Message<"nodebase.v1.DestroyWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId: string;

  /**
   * Destroying compute never implies deleting data (Runtime Contract §14.3):
   * the worker's volumes survive unless this is set explicitly.
   *
   * @generated from field: bool delete_data = 3;
   */
  deleteData: boolean;
};

/**
 * Describes the message nodebase.v1.DestroyWorkerRequest.
 * Use `create(DestroyWorkerRequestSchema)` to create a new message.
 */
export const DestroyWorkerRequestSchema: GenMessage<DestroyWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 32);

/**
 * @generated from message nodebase.v1.DestroyWorkerResponse
 */
export type DestroyWorkerResponse = Message<"nodebase.v1.DestroyWorkerResponse"> & {
};

/**
 * Describes the message nodebase.v1.DestroyWorkerResponse.
 * Use `create(DestroyWorkerResponseSchema)` to create a new message.
 */
export const DestroyWorkerResponseSchema: GenMessage<DestroyWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 33);

/**
 * RebuildWorker replaces the worker's container while keeping its volumes, so
 * the system layer is re-imaged and the user contract — data, identity,
 * service and cron definitions — is restored from persistent state
 * (Runtime Contract §14.2, plan acceptance ④).
 *
 * @generated from message nodebase.v1.RebuildWorkerRequest
 */
export type RebuildWorkerRequest = Message<"nodebase.v1.RebuildWorkerRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId: string;
};

/**
 * Describes the message nodebase.v1.RebuildWorkerRequest.
 * Use `create(RebuildWorkerRequestSchema)` to create a new message.
 */
export const RebuildWorkerRequestSchema: GenMessage<RebuildWorkerRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 34);

/**
 * @generated from message nodebase.v1.RebuildWorkerResponse
 */
export type RebuildWorkerResponse = Message<"nodebase.v1.RebuildWorkerResponse"> & {
};

/**
 * Describes the message nodebase.v1.RebuildWorkerResponse.
 * Use `create(RebuildWorkerResponseSchema)` to create a new message.
 */
export const RebuildWorkerResponseSchema: GenMessage<RebuildWorkerResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_worker, 35);

/**
 * @generated from enum nodebase.v1.WorkerState
 */
export enum WorkerState {
  /**
   * @generated from enum value: WORKER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKER_STATE_PROVISIONING = 1;
   */
  PROVISIONING = 1,

  /**
   * @generated from enum value: WORKER_STATE_REGISTERING = 2;
   */
  REGISTERING = 2,

  /**
   * @generated from enum value: WORKER_STATE_READY = 3;
   */
  READY = 3,

  /**
   * @generated from enum value: WORKER_STATE_DEGRADED = 4;
   */
  DEGRADED = 4,

  /**
   * @generated from enum value: WORKER_STATE_SUSPENDED = 5;
   */
  SUSPENDED = 5,

  /**
   * @generated from enum value: WORKER_STATE_REBUILDING = 6;
   */
  REBUILDING = 6,

  /**
   * @generated from enum value: WORKER_STATE_DESTROYED = 7;
   */
  DESTROYED = 7,
}

/**
 * Describes the enum nodebase.v1.WorkerState.
 */
export const WorkerStateSchema: GenEnum<WorkerState> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_worker, 0);

/**
 * Transport is the Underlay carrier for an endpoint. WG_UDP is preferred;
 * WG_TLS is the authenticated direct same-host fallback. WG_TCP is retired and
 * its number remains reserved only for wire compatibility.
 *
 * @generated from enum nodebase.v1.Transport
 */
export enum Transport {
  /**
   * @generated from enum value: TRANSPORT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPORT_WG_UDP = 1;
   */
  WG_UDP = 1,

  /**
   * @generated from enum value: TRANSPORT_WG_TCP = 2 [deprecated = true];
   * @deprecated
   */
  WG_TCP = 2,

  /**
   * WG datagrams framed inside an authenticated TLS/ShadowTLS stream to the
   * Worker host's shared Transport Gateway. This is a direct same-host path,
   * not an Edge relay; the WG overlay identity remains unchanged.
   *
   * @generated from enum value: TRANSPORT_WG_TLS = 3;
   */
  WG_TLS = 3,

  /**
   * WG datagrams carried inside an authenticated QUIC datagram session to the
   * Worker host's shared Transport Gateway. Like WG_TLS this is a direct,
   * same-host carrier; unlike bare WG_UDP one public IP:port is shared by all
   * Workers and the signed route ticket selects the local loopback target.
   *
   * @generated from enum value: TRANSPORT_WG_QUIC = 4;
   */
  WG_QUIC = 4,
}

/**
 * Describes the enum nodebase.v1.Transport.
 */
export const TransportSchema: GenEnum<Transport> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_worker, 1);

/**
 * WorkerSetupStage is the step a new Worker is on. Each one begins at a fact
 * the control plane records durably; a client shows the stage it is given and
 * does not advance it on a timer.
 *
 * @generated from enum nodebase.v1.WorkerSetupStage
 */
export enum WorkerSetupStage {
  /**
   * @generated from enum value: WORKER_SETUP_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Capacity is reserved; the regional host is setting up other Workers first
   * (queue_ahead of them).
   *
   * @generated from enum value: WORKER_SETUP_STAGE_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * The regional host is building the VM: disk, encryption, release image.
   * The longest step (about a minute on 2026-11-03).
   *
   * @generated from enum value: WORKER_SETUP_STAGE_PREPARING = 2;
   */
  PREPARING = 2,

  /**
   * The VM has been started; waiting for its agent's first authenticated
   * contact.
   *
   * @generated from enum value: WORKER_SETUP_STAGE_STARTING = 3;
   */
  STARTING = 3,

  /**
   * The agent has registered; its network configuration and the regional
   * gateway are converging. Ends when the Worker's state becomes READY.
   *
   * @generated from enum value: WORKER_SETUP_STAGE_CONNECTING = 4;
   */
  CONNECTING = 4,
}

/**
 * Describes the enum nodebase.v1.WorkerSetupStage.
 */
export const WorkerSetupStageSchema: GenEnum<WorkerSetupStage> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_worker, 2);

/**
 * WorkerSetupProblem says whether setup needs anyone's attention. Calling
 * EnsureWorker again is always safe and never needed: a retryable failure is
 * retried by the server.
 *
 * @generated from enum nodebase.v1.WorkerSetupProblem
 */
export enum WorkerSetupProblem {
  /**
   * @generated from enum value: WORKER_SETUP_PROBLEM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The last attempt at this stage failed; the server tries again by itself
   * in retry_in_seconds.
   *
   * @generated from enum value: WORKER_SETUP_PROBLEM_RETRYING = 1;
   */
  RETRYING = 1,

  /**
   * Setup has taken far longer than usual and is still being tried. Worth
   * telling support about; nothing for the user to retry.
   *
   * @generated from enum value: WORKER_SETUP_PROBLEM_SLOW = 2;
   */
  SLOW = 2,

  /**
   * Setup stopped and will not finish without an operator.
   *
   * @generated from enum value: WORKER_SETUP_PROBLEM_STOPPED = 3;
   */
  STOPPED = 3,
}

/**
 * Describes the enum nodebase.v1.WorkerSetupProblem.
 */
export const WorkerSetupProblemSchema: GenEnum<WorkerSetupProblem> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_worker, 3);

/**
 * WorkerService handles worker creation, bootstrap registration, heartbeat, and
 * state reporting (technical plan §3.4, §4.5).
 *
 * @generated from service nodebase.v1.WorkerService
 */
export const WorkerService: GenService<{
  /**
   * CreateWorker and DestroyWorker are operator RPCs: worker lifecycle is
   * managed server-side. A user's worker comes from EnsureWorker.
   *
   * @generated from rpc nodebase.v1.WorkerService.CreateWorker
   */
  createWorker: {
    methodKind: "unary";
    input: typeof CreateWorkerRequestSchema;
    output: typeof CreateWorkerResponseSchema;
  },
  /**
   * EnsureWorker returns the workspace's worker, provisioning one first when
   * none exists. Idempotent; the account-facing way to obtain a worker now
   * that self-serve CreateWorker is operator-only (one worker per user).
   *
   * @generated from rpc nodebase.v1.WorkerService.EnsureWorker
   */
  ensureWorker: {
    methodKind: "unary";
    input: typeof EnsureWorkerRequestSchema;
    output: typeof EnsureWorkerResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.GetWorker
   */
  getWorker: {
    methodKind: "unary";
    input: typeof GetWorkerRequestSchema;
    output: typeof GetWorkerResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.ListWorkers
   */
  listWorkers: {
    methodKind: "unary";
    input: typeof ListWorkersRequestSchema;
    output: typeof ListWorkersResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.RegisterWorker
   */
  registerWorker: {
    methodKind: "unary";
    input: typeof RegisterWorkerRequestSchema;
    output: typeof RegisterWorkerResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.Heartbeat
   */
  heartbeat: {
    methodKind: "unary";
    input: typeof HeartbeatRequestSchema;
    output: typeof HeartbeatResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.ReportState
   */
  reportState: {
    methodKind: "unary";
    input: typeof ReportStateRequestSchema;
    output: typeof ReportStateResponseSchema;
  },
  /**
   * ReportTraffic uploads closed egress accounting windows (technical plan
   * §7.6 ③). Delivery is at-least-once; the server dedupes on the window key
   * and acks what it has durably recorded; the agent marks acked windows
   * reported, stops sending them, and keeps the latest of them locally
   * for `nb traffic`.
   *
   * Privacy contract: the per-window destination list exists only in flight.
   * The server merges destinations into global buckets (all workspaces
   * combined) in the same transaction that records the window, and persists no
   * user↔destination pair — the billing ledger keeps byte totals per
   * workspace, the destination stats keep no workspace. This is a product
   * promise, not an implementation detail; changing it requires a docs-level
   * decision (product architecture §4.8).
   *
   * @generated from rpc nodebase.v1.WorkerService.ReportTraffic
   */
  reportTraffic: {
    methodKind: "unary";
    input: typeof ReportTrafficRequestSchema;
    output: typeof ReportTrafficResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.DestroyWorker
   */
  destroyWorker: {
    methodKind: "unary";
    input: typeof DestroyWorkerRequestSchema;
    output: typeof DestroyWorkerResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.WorkerService.RebuildWorker
   */
  rebuildWorker: {
    methodKind: "unary";
    input: typeof RebuildWorkerRequestSchema;
    output: typeof RebuildWorkerResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_worker, 0);

